import { useAppDispatch } from 'segments/hooks';

import { changeActiveBookingsWaitId, changeActiveBookingWaitTime } from 'features/bookingWait';
import { changeActiveBookingCourt, changeActiveBookingIds, SelectedBookingCourt } from 'features/courtsBooking';
import { changeActiveModal } from 'features/modals';

import { CourtsBookings } from 'widgets/courtsBooking';


const CourtsBooking = () => {
  const dispatch = useAppDispatch();

  const handleBookingClick = (courtInfo: SelectedBookingCourt) => {
    dispatch(changeActiveBookingCourt(courtInfo));
    dispatch(changeActiveModal('booking-court-modal'));
  };

  const handleDetailClick = (bookingIds: number[]) => {
    dispatch(changeActiveBookingIds(bookingIds));
    dispatch(changeActiveModal('booked-court-detail-modal'));
  };

  const handleCreateWaitingList = (time: string) => {
    dispatch(changeActiveModal('create-booking-wait-modal'));
    dispatch(changeActiveBookingWaitTime(time));
  };

  const handleEditWaiting = (bookingWaitsId: number[]) => {
    dispatch(changeActiveModal('edit-booking-wait-modal'));
    dispatch(changeActiveBookingsWaitId(bookingWaitsId));
  };

  const handleOpenWaitingList = (time: string) => {
    dispatch(changeActiveModal('booking-wait-list-modal'));
    dispatch(changeActiveBookingWaitTime(time));
  };

  return (
    <CourtsBookings
      handleBooking={handleBookingClick}
      handleCheckDetail={handleDetailClick}
      createWaitingList={handleCreateWaitingList}
      editWaiting={handleEditWaiting}
      openWaitersList={handleOpenWaitingList}
    />
  );
};

export default CourtsBooking;
